<template>
  <div v-if="currentSession">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Formations'"
          :description="'Aperçu d\'une session de formation'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentSession.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between">
                    <span>
                      Intitulé de la formation :
                      {{ currentSession.formation.intitule }}
                    </span>
                    <span>
                      <router-link
                        title="Aperçu"
                        :to="{
                          name: 'compte_formation-show',
                          params: { id: currentSession.formation.id },
                        }"
                        class="mr-4"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        Aperçu
                      </router-link>
                    </span>
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentSession.formation.reference }}
                  </td>
                  <td class="col-6">
                    Durée :
                    {{ currentSession.formation.duree + ' H' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentSession.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning':
                          currentSession.statut === 0 ||
                          currentSession.statut === 5,
                        'text-danger': currentSession.statut === 3,
                        'text-success':
                          currentSession.statut === 1 ||
                          currentSession.statut === 2 ||
                          currentSession.statut === 4,
                      }"
                    ></i>
                    {{ getStatutSession(currentSession.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" v-if="currentSession.demande">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Statut de votre demande de participation
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning': currentSession.demande.reponse === 0,
                        'text-success': currentSession.demande.reponse === 1,
                        'text-danger': currentSession.demande.reponse === 2,
                      }"
                    ></i>
                    {{
                      getReponseParticipation(currentSession.demande.reponse)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <b-alert
      :show="errorMessage !== null"
      dismissible
      variant="danger"
      class="mt-3"
    >
      <span v-html="errorMessage"></span>
    </b-alert>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'compte_formation_show_session',
                params: { id: currentSession.formation.id },
              })
              .catch(() => {})
          "
        >
          Liste des sessions de formation
        </button>
      </div>
      <div class="col-md-12 col-lg-6" v-if="currentSession.statut == 1">
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          v-if="
            user.profil_type === CONST.EMPLOYE_PROFIL && !currentSession.demande
          "
          @click="participer"
        >
          Je veux participer
        </button>

        <b-button
          variant="danger"
          class="btn-icon"
          v-if="currentSession.demande"
          @click="annulerParticipation"
        >
          <span class="btn-icon-label">
            <i class="fas fa-thumbs-down"></i>
          </span>
          Anuuler
        </b-button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'compte_formation_show_session-show',
                params: { sessionId: currentSession.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Session de formation</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'compte_formation_show_session-document',
                params: {
                  sessionId: currentSession.id,
                  documentUuid: currentSession.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import URL from '@/http/compte/formation/session';
import CONST from '@/constants/auth';
export default {
  data() {
    return {
      CONST,
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters('formationSession', ['currentSession']),
  },

  methods: {
    ...mapActions('formationSession', ['getSession', 'setCurrentSession']),
    init() {
      this.setCurrentSession(null);
      window.axios
        .get(URL.SESSION + '/' + this.$route.params.sessionId)
        .then((resp) => {
          this.setCurrentSession(resp.data.session);
        })
        .catch();
    },
    participer() {
      this.errorMessage = null;
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .post(URL.PARTICIPER, {
              formation_session: this.currentSession.uuid,
            })
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch((err) => {
              window._.forEach(err.response.data.errors, (value, key) => {
                if (key.includes('Error')) {
                  this.errorMessage = value[0];
                }
                return false;
              });
            });
        }
      });
    },
    annulerParticipation() {
      this.errorMessage = null;
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .delete(URL.ANNULER_PARTICIPATION, {
              params: {
                session_participation: this.currentSession.demande.id,
              },
            })
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch((err) => {
              window._.forEach(err.response.data.errors, (value, key) => {
                if (key.includes('Error')) {
                  this.errorMessage = value[0];
                }
                return false;
              });
            });
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
